import { supabase } from '../supabase';

class PresenceService {
  private channel: any = null;
  private userId: string | null = null;

  init(userId: string, organizationId: string, displayName: string) {
    this.userId = userId;
    this.channel = supabase.channel(`presence:${organizationId}`, {
      config: { presence: { key: userId } },
    });

    this.channel
      .on('presence', { event: 'sync' }, () => {})
      .subscribe(async (status: string) => {
        if (status === 'SUBSCRIBED') {
          await this.channel.track({
            user_id: userId,
            display_name: displayName,
            online_at: new Date().toISOString(),
          });
        }
      });
  }

  disconnect() {
    if (this.channel) {
      this.channel.untrack();
      supabase.removeChannel(this.channel);
      this.channel = null;
    }
  }
}

export const presenceService = new PresenceService();
